export default "__VITE_ASSET__DJj8Rh_b__"